function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "2.99%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0.75
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-gradient",
  fill: "url(#a)",
  d: "M0 3h49L33.206 31H15.794zM59 3h49L92.206 31H74.794z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-gradient",
  fill: "url(#a)",
  d: "M30 3h49L63.206 31H45.794z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M23 44h3v9a2 2 0 002 2h25V5h3v50h24a2 2 0 002-2v-9h3v10a4 4 0 01-4 4H27a4 4 0 01-4-4V44z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M23.5 44.5V54a3.5 3.5 0 003.5 3.5h54a3.5 3.5 0 003.5-3.5v-9.5h-2V53a2.5 2.5 0 01-2.5 2.5H55.5v-50h-2v50H28a2.5 2.5 0 01-2.5-2.5v-8.5h-2z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M41 0h27c-1.774 4.632-7.147 8-13.5 8S42.774 4.632 41 0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M41.758.5c1.974 4.148 7.002 7 12.742 7 5.74 0 10.768-2.852 12.742-7H41.758z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M13 28h22l-5.382 18H18.382z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M13.671 28.5l5.083 17h10.492l5.083-17H13.67z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M72 28h22l-5.382 18H77.382z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M72.671 28.5l5.083 17h10.492l5.083-17H72.67z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M43 28h22l-5.382 18H48.382z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M43.671 28.5l5.083 17h10.492l5.083-17H43.67z"
}));

function SvgRoomElectricityLightChandelier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 58,
    viewBox: "0 0 108 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricityLightChandelier);
export default __webpack_public_path__ + "static/media/RoomElectricityLightChandelier.55cbf544.svg";
export { ForwardRef as ReactComponent };